import * as preact from "preact";

import * as analytics from "analytics";
import PreactSubviewManager from "PreactSubviewManager";
import {
  GuideEntryPopUpComponent,
  type GuideEntryPopUpOptions,
} from "views/GuideEntryPopUpView";
import { WordPopUpComponent, type WordPopUpOptions } from "views/WordPopUpView";

let wordPopUpMountElement: HTMLDivElement | undefined;
const preactSubviewManager = new PreactSubviewManager();

export const removeReaderWordPopUp = () => {
  preactSubviewManager.remove("wordPopUp");
  wordPopUpMountElement?.remove();
  wordPopUpMountElement = undefined;
};

export const showReaderWordPopUp = (wordPopUpOptions: WordPopUpOptions) => {
  removeReaderWordPopUp();

  wordPopUpMountElement = document.createElement("div");
  wordPopUpMountElement.className = "yourWordPopUpContainer";
  wordPopUpOptions.containerElement[0].appendChild(wordPopUpMountElement);

  preactSubviewManager.add(
    "wordPopUp",
    preact.h(WordPopUpComponent as any, {
      ...wordPopUpOptions,
      mountEl: wordPopUpMountElement,
      onClose: removeReaderWordPopUp,
    }),
    wordPopUpMountElement
  );

  analytics.trackEvent("openWordPopUp");
};

/**
 * Shows the reading-guide glossary popover for a clicked word. Mounted under
 * the same key as the word popup so the two can never be shown together.
 */
export const showGuideEntryPopUp = (options: GuideEntryPopUpOptions) => {
  removeReaderWordPopUp();

  wordPopUpMountElement = document.createElement("div");
  wordPopUpMountElement.className = "yourWordPopUpContainer";
  options.containerElement[0].appendChild(wordPopUpMountElement);

  preactSubviewManager.add(
    "wordPopUp",
    preact.h(GuideEntryPopUpComponent as any, {
      ...options,
      mountEl: wordPopUpMountElement,
      onClose: removeReaderWordPopUp,
    }),
    wordPopUpMountElement
  );

  analytics.trackEvent("openGuideEntryPopUp");
};
